export const PLAYBACK_FAILED_MESSAGE =
  "Couldn't play this recording. The file may be unavailable or in an unsupported format.";
export const PLAYBACK_BLOCKED_MESSAGE =
  "Your browser blocked playback. Interact with the page and try again.";
